export { default, StyledLabel } from './Label';
export type { LabelProps } from './Label';
